"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-prototype-of.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.assign.js");

var _events = _interopRequireDefault(require("events"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _defaults = _interopRequireDefault(require("lodash/defaults"));

var _detectNode = _interopRequireDefault(require("detect-node"));

var _debug = _interopRequireDefault(require("debug"));

var _config = _interopRequireDefault(require("../config"));

var _methods = _interopRequireDefault(require("./methods"));

var _utils = require("../utils");

var _promisify = require("../promisify");

var _transports = _interopRequireDefault(require("./transports"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var debugEmitters = (0, _debug.default)('golos:emitters');
var debugSetup = (0, _debug.default)('golos:setup');
var DEFAULTS = {
  id: 0
};

var Golos = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Golos, _EventEmitter);

  var _super = _createSuper(Golos);

  function Golos() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Golos);

    _this = _super.call(this, options);
    (0, _defaults.default)(options, DEFAULTS);
    _this.options = (0, _cloneDeep.default)(options);
    _this._streamDefaults = {
      mode: 'head',
      startBlock: 0
    };
    return _this;
  }

  _createClass(Golos, [{
    key: "_setTransport",
    value: function _setTransport(url) {
      if (url && url.match('^((http|https)?:\/\/)')) {
        this.transport = new _transports.default.http();
        this.url = url;
      } else if (url && url.match('^((ws|wss)?:\/\/)')) {
        this.transport = new _transports.default.ws();
        this.url = url;
      } else {
        throw Error("unknown transport! [" + url + "]");
      }
    }
  }, {
    key: "setWebSocket",
    value: function setWebSocket(url) {
      console.warn("golos.api.setWebSocket(url) is now deprecated instead use golos.config.set('websocket',url)");
      debugSetup('Setting WS', url);

      _config.default.set('websocket', url);

      this._setTransport(url);

      this.stop();
    }
  }, {
    key: "start",
    value: function start() {
      var url = _config.default.get('websocket');

      this._setTransport(url);

      return this.transport.start();
    }
  }, {
    key: "stop",
    value: function stop() {
      debugSetup('Stopping...');
      var ret = this.transport.stop();
      this.transport = null;
      this.url = null;
      return ret;
    }
  }, {
    key: "send",
    value: function send(api, data, callback) {
      debugSetup('Golos::send', api, data);

      if (!this.transport) {
        this.start();
      } else {
        var url = _config.default.get('websocket');

        if (url !== this.url) {
          debugSetup('websocket URL changed, restarting transport...');
          this.stop();
          this.start();
        }
      }

      return this.transport.send(api, data, callback);
    }
  }, {
    key: "callReliable",
    value: function callReliable(method) {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var callback = args[args.length - 1];
      var argsWithoutCb = args.slice(0, args.length - 1);
      this[method].apply(this, _toConsumableArray(argsWithoutCb).concat([function (err, result) {
        if (err || !result) {
          console.error(method + ' reliable call - fail, retrying... Cause:', err ? err.message : 'API returned null');
          setTimeout(function () {
            _this2.callReliable.apply(_this2, [method].concat(args));
          }, 1000);
          return;
        }

        callback(null, result);
      }]));
    }
  }, {
    key: "streamBlockNumber",
    value: function streamBlockNumber(options, callback) {
      var _this3 = this;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      (0, _defaults.default)(options, this._streamDefaults);
      var startBlock = options.startBlock;
      var prevBlock = 0;
      var running = true;

      var update = function update() {
        if (!running) return;

        _this3.callReliableAsync('getDynamicGlobalProperties').then(function (result) {
          var currentBlock = options.mode === 'irreversible' ? result.last_irreversible_block_num : result.head_block_number;
          if (!startBlock) startBlock = currentBlock;

          for (var i = startBlock; i <= currentBlock; i++) {
            var ret = callback(null, i);
            if (ret === true || !running) return;
          }

          startBlock = currentBlock + 1;
          setTimeout(function () {
            update();
          }, 1000);
        }, function (err) {
          callback(err);
        });
      };

      update();
      return function () {
        running = false;
      };
    }
  }, {
    key: "streamBlock",
    value: function streamBlock(options, callback) {
      var _this4 = this;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      (0, _defaults.default)(options, this._streamDefaults);
      var current = '';
      var last = '';
      var release = this.streamBlockNumber(options, function (err, id) {
        if (err) {
          release();
          callback(err);
          return;
        }

        current = id;

        if (current !== last) {
          last = current;

          _this4.callReliable('getBlock', current, function (err, res) {
            res.block_num = current;
            res.timestamp_prev = new Date(new Date(res.timestamp).getTime() - 3000).toISOString().split('.')[0];
            var ret = callback(err, res);
            if (ret === true) release();
          });
        }
      });
      return release;
    }
  }, {
    key: "streamTransactions",
    value: function streamTransactions(options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      (0, _defaults.default)(options, this._streamDefaults);
      var release = this.streamBlock(options, function (err, block) {
        if (err) {
          release();
          callback(err);
          return;
        }

        if (block && block.transactions) {
          block.transactions.forEach(function (transaction) {
            var ret = callback(null, transaction, block);
            if (ret === true) release();
          });
        }
      });
      return release;
    }
  }, {
    key: "streamOperations",
    value: function streamOperations() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      (0, _defaults.default)(options, this._streamDefaults);
      var release = this.streamTransactions(options, function (err, transaction, block) {
        if (err) {
          release();
          callback(err);
          return;
        }

        transaction.operations.forEach(function (operation) {
          var ret = callback(null, operation, transaction, block);
          if (ret === true) release();
        });
      });
      return release;
    }
  }, {
    key: "streamEvents",
    value: function streamEvents(options, callback) {
      var _this5 = this;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      (0, _defaults.default)(options, this._streamDefaults);
      var current = '';
      var last = '';
      var release = this.streamBlockNumber(options, function (err, id) {
        if (err) {
          release();
          callback(err);
          return;
        }

        current = id;

        if (current !== last) {
          last = current;

          _this5.callReliable('getEventsInBlock', current, false, function (err, res) {
            var _iterator = _createForOfIteratorHelper(res),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var eventMeta = _step.value;
                var ret = callback(err, eventMeta.op, eventMeta);
                if (ret === true) release();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          });
        }
      });
      return release;
    }
  }]);

  return Golos;
}(_events.default); // Generate Methods from methods.js


_methods.default.forEach(function (method) {
  var methodName = method.method_name || (0, _utils.camelCase)(method.method);
  var methodParams = method.params || [];
  var defaultParms = {};
  var hasDefaultValues = method.has_default_values;

  if (hasDefaultValues) {
    methodParams.forEach(function (param) {
      var _param$split = param.split('='),
          _param$split2 = _slicedToArray(_param$split, 2),
          p = _param$split2[0],
          value = _param$split2[1];

      defaultParms[p] = value ? JSON.parse(value) : '';
    });
  }

  Golos.prototype["".concat(methodName, "With")] = function Golos$$specializedSendWith(options, callback) {
    var params = methodParams.map(function (param) {
      return options[hasDefaultValues ? param.split('=')[0] : param];
    });
    return this.send(method.api, {
      method: method.method,
      params: params
    }, callback);
  };

  Golos.prototype[methodName] = function Golos$specializedSend() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var options = {};

    if (hasDefaultValues) {
      var argsWithoutCb = args.slice(0, args.length - 1);
      methodParams.forEach(function (param, i) {
        var _param$split3 = param.split('='),
            _param$split4 = _slicedToArray(_param$split3, 2),
            p = _param$split4[0],
            value = _param$split4[1];

        if (argsWithoutCb[i]) {
          options[p] = argsWithoutCb[i];
        }
      });
      options = Object.assign({}, defaultParms, options);
    } else {
      var opt = methodParams.reduce(function (memo, param, i) {
        memo[param] = args[i];
        return memo;
      }, {});
      options = Object.assign({}, opt);
    }

    var callback = args[hasDefaultValues ? args.length - 1 : methodParams.length];
    return this["".concat(methodName, "With")](options, callback);
  };
});

(0, _promisify.promisifyAll)(Golos.prototype);

Golos.prototype['setBlockAppliedCallback'] = function Golos$setCallback(type, callback) {
  return this.send('database_api', {
    method: 'set_block_applied_callback',
    params: [type]
  }, callback);
};

Golos.prototype['setPendingTransactionCallback'] = function Golos$setCallback(callback) {
  return this.send('database_api', {
    method: 'set_pending_transaction_callback',
    params: []
  }, callback);
};

Golos.prototype['setPrivateMessageCallback'] = function Golos$setCallback(query, callback) {
  return this.send('private_message', {
    method: 'set_callback',
    params: [query]
  }, callback);
}; // Export singleton instance


var golos = new Golos();
exports = module.exports = golos;
exports.Golos = Golos;
exports.Golos.DEFAULTS = DEFAULTS;